import { COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  layout?: {
    width?: string;
    maxWidth?: string;
    margin?: string;
    padding?: string;
    titlePadding?: string;
    descriptionPadding?: string;
  };
  titleSubtitle?: {
    title?: string;
    subtitle?: string;
  };
  specs?: {
    title: string;
    subtitle: string;
  }[];
  tabs?: {
    label: string;
    imageUrl: string;
    imageAlt?: string;
    description: string;
  }[];
  colorTheme?: 'DARK' | 'LIGHT';
  editor?: object;
}

const propsSchema: PropsSchemaList = [
  {
    key: 'layout',
    label: 'Layout',
    type: types.OBJECT,
    children: [
      {
        key: 'width',
        label: 'Width',
        type: types.TEXT,
      },
      {
        key: 'maxWidth',
        label: 'Max Width',
        type: types.TEXT,
      },
      {
        key: 'margin',
        label: 'Margin',
        type: types.TEXT,
      },
      {
        key: 'padding',
        label: 'Padding',
        type: types.TEXT,
      },
      {
        key: 'titlePadding',
        label: 'Title Padding',
        type: types.TEXT,
      },
      {
        key: 'descriptionPadding',
        label: 'Description Padding',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'titleSubtitle',
    label: 'Title and Subtitle',
    type: types.OBJECT,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'subtitle',
        label: 'Subtitle',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'specs',
    label: 'Specifications',
    type: types.ARRAY,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'subtitle',
        label: 'Subtitle',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'tabs',
    label: 'Tabs',
    type: types.ARRAY,
    children: [
      {
        key: 'label',
        label: 'Tab Label',
        type: types.TEXT,
      },
      {
        key: 'imageUrl',
        label: 'Image URL',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'imageAlt',
        label: 'Image Alt Text',
        tooltip: 'This is important for SEO and accessibility. This is not shown on the page.',
        type: types.TEXT,
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXTAREA,
      },
    ]
  },
  {
    key: 'colorTheme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES,
  },
];

export const defaultProps: Props = {
  titleSubtitle: {
    title: 'Title',
    subtitle: 'Subtitle',
  },
  specs: [
    { title: 'Spec One', subtitle: 'Subtitle One' },
    { title: 'Spec Two', subtitle: 'Subtitle Two' },
    { title: 'Spec Three', subtitle: 'Subtitle Three' },
  ],
  tabs: [
    {
      label: 'First Tab',
      imageUrl: 'https://genesis-cdn.ff.com/press_room/2025-10/1028Teaser/2880-Burj-default.jpg',
      imageAlt: 'FX Super One and Burj Khalifa',
      description: 'Description for the first tab'
    },
    {
      label: 'Second Tab',
      imageUrl: 'https://genesis-cdn.ff.com/press_room/2025-10/1028Teaser/w-h-b0-q90-c0-8-default.jpg',
      imageAlt: 'FX Super One in an open space',
      description: 'Description for the second tab'
    },
    {
      label: 'Third Tab',
      imageUrl: 'https://genesis-cdn.ff.com/press_room/2025-10/1028Teaser/_C3A5148-default.jpg',
      imageAlt: 'FX Super One driving down the road',
      description: 'Description for the third tab'
    },
  ],
  colorTheme: 'LIGHT',
};

export default {
  title: 'Tab Carousel',
  id: 'TabCarousel',
  propsSchema,
  defaultProps,
}
